import { render, staticRenderFns } from "./StockMoveReason.vue?vue&type=template&id=708e8ad4&scoped=true&"
import script from "./StockMoveReason.vue?vue&type=script&lang=js&"
export * from "./StockMoveReason.vue?vue&type=script&lang=js&"
import style0 from "./StockMoveReason.vue?vue&type=style&index=0&id=708e8ad4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708e8ad4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCheckbox,VDataTable,VLayout})
